<!-- <div class="vendortitle">In Process Vendors</div>
<div class="subtitle mb-4">List of In Process KBL Vendors</div> -->


<div *ngIf="isJsonShow">
  <span>{{ userData | json }}</span>
</div>


<!-- <span>{{userData | json}}</span> -->
<!-- ========= Approval Matrix Status Progressbar =========  -->
<!-- <app-approval-status-progressbar></app-approval-status-progressbar> -->

<div class="vendordetails mt-4">
  <div class="vendor-steps left-steps ml-auto">

    <nb-stepper #stepper linear="false"  orientation="horizontal" (stepChange)="onStepChange($event)">

      <nb-step [label]="'Seva Profile'" *ngIf="effectiveTabConfig.showSevaProfile">
        <app-preview-seva-profile *ngIf="currentStep === 'Seva Profile'"></app-preview-seva-profile>
      </nb-step>



      <nb-step [label]="'Visiting Seva'" *ngIf="effectiveTabConfig.showVisitingSeva">
        <app-preview-visiting-seva *ngIf="currentStep === 'Visiting Seva'"></app-preview-visiting-seva>
      </nb-step>

      <nb-step [label]="'PTH View'" *ngIf="effectiveTabConfig.showPthView">
        <app-preview-pth *ngIf="currentStep === 'PTH View'"></app-preview-pth>
      </nb-step>

      <nb-step [label]="'COC Reference'" *ngIf="effectiveTabConfig.showCocReference">
        <div class="step-container">
          <div class="step-subtitle mb-4"><app-add-reference
              *ngIf="currentStep === 'COC Reference'"></app-add-reference></div>
        </div>
      </nb-step>

      <nb-step [label]="'Notes'" *ngIf="effectiveTabConfig.showNotes">
        <app-all-notes-list *ngIf="currentStep === 'Notes'"></app-all-notes-list>
      </nb-step>

      <nb-step [label]="'Audit History'" *ngIf="effectiveTabConfig.showAuditHistory">
        <div class="step-container">
          <app-audit-history-grid *ngIf="currentStep === 'Audit History'" [config]="auditHistoryConfig"></app-audit-history-grid>
        </div>
      </nb-step>

      <nb-step [label]="'Action'" *ngIf="effectiveTabConfig.showAction">
     
        <app-approve-rected-action *ngIf="currentStep === 'Action'"></app-approve-rected-action>
      </nb-step>




    </nb-stepper>
  </div>
</div>